<template>
  <div class="about-us-item">
    <div class="row justify-content-between align-items-center" :class="index % 2 === 1 ? 'flex-lg-row-reverse' : ''">

      <div class="col-lg-7 col-12">
        <div class="about-us-item__image-container" :class="index % 2 === 1  ? 'margin-left-lg-25' : 'margin-right-lg-25'">
          <img class="about-us-item__image" :src="aboutUsItem.image.url" :alt="aboutUsItem.image.alt" />
          <div class="about-us-item__title-container d-flex justify-content-center align-items-center">
            <div class="about-us-item__red-block"></div>
            <h3 class="about-us-item__title">{{ aboutUsItem.title }}</h3>
          </div>
        </div>
      </div>

      <div class="col-lg-5 col-12">
        <p>{{ aboutUsItem.description }}</p>
        <ButtonRed text="Learn more" hyperlink :href="aboutUsItem.url" />
      </div>

    </div>
  </div>
</template>

<script>
import ButtonRed from '../common/ButtonRed.vue';


export default {
  components: { ButtonRed },
  props: {
    aboutUsItem: {
      id: String,
      title: String,
      description: String,
      url: String,
      image: {
        url: String,
        alt: String,
      },
    },
    index: Number,
  },
}
</script>

